import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import MultiSelectBox from '../../Common/MultiSelectBox/MultiSelectBox';
import TextArea from '../../Common/TextArea';
import InputText from '../../Common/InputText';
import Icon from '../../Common/Icon';
import Toggle from '../../Common/Toggle/Toggle';
import { MAX_NUM_TASK_LINKS } from '../../../constants/constants';

/**
 * LOCATION-CREATED Task Detail: Add/Edit a task at the location.  These
 * tasks will not be associated with a baseline task at all.  They're created
 * directly at one particular location.
 */
export class LocationTaskDetailDrawerForm extends React.Component {
    constructor(props, context) {
        super(props, context);

        this.state = {
            displayMoreOptions: false,
            showContingentDropdown: false,
            showSuccessorDropdown: false
        }
    }

    isAddMode = () => {
        return this.props.task.id === 0;
    }

    isEditMode = () => {
        return !this.isAddMode();
    }

    toggleIsMilestone = () => {
        this.props.onTaskChange("isMilestone", !this.props.task.isMilestone);
    }

    toggleDisplayMoreOptions = (e) => {
        e.preventDefault();
        this.setState({ displayMoreOptions: !this.state.displayMoreOptions });
    }

    onToggleChange = (name, checked) => {
        this.props.onTaskChange(name, checked);
    }

    onFormChange = (e) => {
        this.props.onTaskChange(e.target.name, e.target.value);
    }

    onDropdownChange = (name, value) => {
        // Do not send a null value on a dropdown change
        if (value) {
            this.props.onTaskChange(name, value);
        }
    }

    addLink = () => {
        let links = this.props.task.links.slice();
        if (links.length < MAX_NUM_TASK_LINKS) {
            links.push({
                id: 0,
                name: '',
                url: '',
                isActive: true,
                ordinal: links.length,
                isFile: false
            });
            this.props.onTaskChange("links", links);
        }
    }

    onLinkChange = (link, index, field, event) => {
        let links = this.props.task.links.slice();
        link[field] = event.target.value;
        links.splice(index, 1, link);
        this.props.onTaskChange("links", links);
    }

    showContingentDropdown = (e) => {
        e.preventDefault();
        this.setState({ showContingentDropdown: true });
    }

    showSuccessorDropdown = (e) => {
        e.preventDefault();
        this.setState({ showSuccessorDropdown: true });
    }

    onEditContingentClick = (e) => {
        e.preventDefault();
        this.setState({ showContingentDropdown: true });
    }

    renderAddModeRelatedTaskSection = () => {
        const showContingentAndSuccessorLinks = this.props.isTaskDependenciesActive && this.isAddMode() && !this.state.showContingentDropdown && !this.state.showSuccessorDropdown;
        return (
            <Fragment>
                {
                    showContingentAndSuccessorLinks &&
                    <div className="row">
                        <div className="col-12">
                            <div className="alert alert-secondary">
                                <button className="btn btn-link" onClick={(e) => this.showSuccessorDropdown(e)}>Assign a prerequisite task</button>
                                <button className="btn btn-link" onClick={(e) => this.showContingentDropdown(e)}>Make this a prerequisite of...</button>
                            </div>
                        </div>
                    </div>
                }
                {
                    this.state.showContingentDropdown &&
                    <div className="row">
                        <div className="col-6 col-xs-12">
                            <div className="alert alert-secondary">
                                <MultiSelectBox name="contingentId" idField="id" valueField="name"
                                    label="Contingent"
                                    options={this.props.contingentTasks}
                                    selectedValues={this.props.task.contingentId.toString()}
                                    onChange={(id) => this.props.onTaskChange("contingentId", id.toString())}
                                    isMulti={false}
                                />
                            </div>
                        </div>
                    </div>
                }
                {
                    this.state.showSuccessorDropdown &&
                    <div className="row">
                        <div className="col-6 col-xs-12">
                            <div className="alert alert-secondary">
                                <MultiSelectBox name="successorId" idField="id" valueField="name"
                                    label="Successor"
                                    options={this.props.successorTasks}
                                    selectedValues={this.props.task.successorId.toString()}
                                    onChange={(id) => this.props.onTaskChange("successorId", id.toString())}
                                    isMulti={false}
                                />
                            </div>
                        </div>
                    </div>
                }
            </Fragment>
        );
    }

    renderEditModeRelatedTaskSection = () => {
        const hasContingent = this.props.task.contingentId && this.props.task.contingentTaskName !== "" && this.props.task.contingentTaskName;
        const showContingentLink = !this.state.showContingentDropdown && hasContingent;
        const showSuccessorLink = this.props.task.successorTasks?.length > 0;
        const showAddContingent = !this.state.showContingentDropdown && !hasContingent;

        return (
            <Fragment>
                {
                    showSuccessorLink &&
                    <div className="row">
                        <div className="col-12">
                            <div className="alert alert-secondary prereq-alert">
                                <span className="font-weight-bold">Prerequisites for this task:</span>
                                {this.props.task.successorTasks.map((task) => (
                                    <div key={task.id}>
                                        <button className="btn btn-link" onClick={(e) => this.props.showPrereqDrawer(e, task.id)}>
                                            <span className={`task-status-label core-status-${task.coreStatusId}`}>
                                                {task.status.toUpperCase()}
                                            </span>
                                            {task.name}
                                        </button>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                }

                {
                    showAddContingent &&
                    <div className="row">
                        <div className="col-12">
                            <div className="alert alert-secondary">
                                <button className="btn btn-link" onClick={(e) => this.showContingentDropdown(e)}>Make this a prerequisite of...</button>
                            </div>
                        </div>
                    </div>
                }
                {
                    this.state.showContingentDropdown &&
                    <div className="row">
                        <div className="col-6 col-xs-12">
                            <div className="alert alert-secondary">
                                <MultiSelectBox name="contingentId" idField="id" valueField="name"
                                    label="Contingent"
                                    options={this.props.contingentTasks}
                                    selectedValues={this.props.task.contingentId.toString()}
                                    onChange={(id) => this.props.onTaskChange("contingentId", id.toString())}
                                    isMulti={false}
                                />
                            </div>
                        </div>
                    </div>
                }
                {
                    showContingentLink &&
                    <div className="row">
                        <div className="col-12">
                            <div className="alert alert-secondary contingent-alert">
                                <div className="font-weight-bold me-2">This task is a prerequisite of:</div>
                                <div>
                                    <button className="btn btn-link" onClick={(e) => this.props.showContingentDrawer(e)}>
                                        <span className={`task-status-label core-status-${this.props.task.contingentTaskCoreStatusId}`}>
                                            {this.props.task.contingentTaskStatus.toUpperCase()}
                                        </span>{this.props.task.contingentTaskName}
                                    </button>
                                    <span className="contingent-icon" onClick={this.onEditContingentClick} title="Edit Contingent"><Icon name="pencil-alt" /></span>
                                    <span className="contingent-icon delete" onClick={this.props.onDeleteContingentClick} title="Delete Contingent"><Icon name="trash-alt" /></span>
                                </div>
                            </div>
                        </div>
                    </div>
                }
            </Fragment>
        );
    }

    render() {
        const milestoneLinkText = (this.props.task.isMilestone) ? "Make Task" : "Make Milestone Task";
        const milestoneInputText = (this.props.task.isMilestone) ? "Milestone Task Name" : "Task Name";
        const isAssignedToMe = this.props.task.responsibleUserId && this.props.currentUserId.toString() === this.props.task.responsibleUserId.toString();

        return (
            <div className="task-detail-wrapper">
                {
                    this.isAddMode() ?
                        this.renderAddModeRelatedTaskSection()
                        :
                        this.renderEditModeRelatedTaskSection()
                }
                <form noValidate className={this.props.isFormValid ? "" : "was-validated"} >
                    <div className="row">
                        <div className="col-xs-12 col-sm-6">

                            <div className="task-detail-section">
                                <div className="row">
                                    <div className="col-12 milestone text-end">
                                        <button type="button" className="btn btn-link" onClick={this.toggleIsMilestone}>{milestoneLinkText}</button>
                                    </div>
                                </div>
                                <TextArea rows={2} name="name" label={milestoneInputText} placeholder={milestoneInputText} value={this.props.task.name} isRequired={true} errorMessage="Name is required" onChange={this.onFormChange} />
                                <TextArea rows={2} name="additionalInfo" placeholder="Additional Info" label="Additional Info" value={this.props.task.additionalInfo} onChange={this.onFormChange} />
                            </div>

                            <div className="task-detail-section">
                                {
                                    this.isAddMode() && // Hide responsible user in Edit mode
                                    <Fragment>
                                        <MultiSelectBox className="responsible-user mb-3" name="userId" idField="id" valueField="name"
                                            label="Responsible User"
                                            options={this.props.responsibleUsers}
                                            selectedValues={this.props.task.responsibleUserId.toString()}
                                            onChange={(id) => this.onDropdownChange("responsibleUserId", id)}
                                            isRequired={false}
                                            errorMessage="Responsible User is required"
                                            isMulti={false}
                                        />
                                        {
                                            !isAssignedToMe &&
                                            <button className="me-3 btn btn-link assign-to-me" onClick={() => this.props.onTaskChange("responsibleUserId", this.props.currentUserId.toString())}>Assign Task to Me</button>
                                        }
                                    </Fragment>
                                }

                                <Fragment>
                                    <MultiSelectBox name="departmentId" idField="id" valueField="name"
                                        label="Department"
                                        options={this.props.departments}
                                        selectedValues={this.props.task.departmentId.toString()}
                                        onChange={(id) => this.props.onTaskChange("departmentId", id.toString())}
                                        isRequired={true}
                                        errorMessage="Department is required"
                                        isMulti={false}
                                    />

                                    <MultiSelectBox name="communityId" idField="id" valueField="name"
                                        label="Community"
                                        options={this.props.communities}
                                        selectedValues={this.props.task.communityId.toString()}
                                        onChange={(id) => this.props.onTaskChange("communityId", id.toString())}
                                        isRequired={true}
                                        errorMessage="Community is required"
                                        isMulti={false}
                                    />
                                </Fragment>

                                {
                                    this.props.isProjectWidgetActive &&
                                    <MultiSelectBox name="projectId" idField="id" valueField="name"
                                        label="Project"
                                        options={this.props.projects}
                                        selectedValues={this.props.task.projectId.toString()}
                                        onChange={(id) => this.props.onTaskChange("projectId", id.toString())}
                                        isRequired={(this.props.isProjectIdRequiredForLocationTask) ? true : false}
                                        errorMessage="Project is required"
                                        isMulti={false}
                                    />
                                }
                            </div>

                            {
                                this.state.displayMoreOptions &&

                                <div className="task-detail-section">
                                    <MultiSelectBox name="phaseId" idField="id" valueField="name"
                                        label="Phase"
                                        options={this.props.phases}
                                        selectedValues={this.props.task.phaseId.toString()}
                                        onChange={(id) => this.props.onTaskChange("phaseId", id.toString())}
                                        isMulti={false}
                                    />
                                    {
                                        this.isAddMode() && // Hide links in Edit Mode
                                        <Fragment>
                                            <div className="title">Links</div>
                                            {
                                                this.props.task.links.map((link, index) => {
                                                    return (<table className="links" key={link.ordinal}>
                                                        <tbody>
                                                            <tr>
                                                                <td><InputText
                                                                    name="linkUrl"
                                                                    label="Link URL"
                                                                    type="text"
                                                                    placeholder="Link URL"
                                                                    value={link.url}
                                                                    onChange={(e) => this.onLinkChange(link, index, "url", e)} /></td>
                                                                <td className="td-spacer"></td>
                                                                <td><InputText
                                                                    name="linkName"
                                                                    label="Link Abbreviation"
                                                                    type="text"
                                                                    placeholder="Link Abbreviation"
                                                                    value={link.name}
                                                                    onChange={(e) => this.onLinkChange(link, index, "name", e)}
                                                                    isRequired={link.url !== ""}
                                                                    errorMessage="Abbreviation Required" /></td>
                                                            </tr>
                                                        </tbody>
                                                    </table>);
                                                })
                                            }
                                            {
                                                this.props.task.links.length < MAX_NUM_TASK_LINKS &&
                                                <button type="button" className="btn btn-link remove-mt add-link" onClick={this.addLink}>Add Link</button>
                                            }
                                        </Fragment>
                                    }

                                    <div className="title">Contact for Assistance</div>
                                    <table>
                                        <tbody>
                                            <tr>
                                                <td><InputText name="contactName" label="Contact Name" type="text" placeholder="Contact Name" value={this.props.task.contactName} onChange={this.onFormChange} /></td>
                                                <td className="td-spacer"></td>
                                                <td><InputText name="contactEmail" label="Contact Email" type="email" placeholder="Contact Email" value={this.props.task.contactEmail} onChange={this.onFormChange} /></td>
                                            </tr>
                                        </tbody>
                                    </table>
                                    {this.props.isProjectWidgetActive === false &&
                                        <div>
                                            <Toggle name="isLocationTaskDateAdjustable" text="Adjust Dates if Opening Date changes" checked={this.props.task.isLocationTaskDateAdjustable} onChange={this.onToggleChange} />
                                        </div>
                                    }

                                    {
                                        this.isEditMode() &&
                                        <div className="basic-info-section">
                                            <span className="info-key">Location Task Id:</span>
                                            <span className="info-value">{this.props.task.id}</span>
                                        </div>
                                    }
                                </div>
                            }
                            {
                                this.state.displayMoreOptions
                                    ?
                                    <button className="btn btn-link display-more-options" onClick={this.toggleDisplayMoreOptions}>Display Fewer Options</button>
                                    :
                                    <button className="btn btn-link display-more-options" onClick={this.toggleDisplayMoreOptions}>Display More Options</button>
                            }
                        </div>

                        <div className="col-xs-12 col-sm-6 right-col">
                            <div className="task-detail-section">
                                {
                                    this.isAddMode() && // Hide Status in Edit Mode
                                    <MultiSelectBox name="statusId" idField="id" valueField="name"
                                        label="Status"
                                        options={this.props.statuses}
                                        selectedValues={this.props.task.statusId.toString()}
                                        onChange={(id) => this.props.onTaskChange("statusId", id.toString())}
                                        isMulti={false}
                                        isRequired={true}
                                        errorMessage="Status is required"
                                    />
                                }
                            </div>
                        </div>
                    </div>
                </form>
            </div>
        );
    }
}

LocationTaskDetailDrawerForm.propTypes = {
    isFormValid: PropTypes.bool.isRequired,
    currentUserId: PropTypes.number.isRequired,
    task: PropTypes.object.isRequired,
    onTaskChange: PropTypes.func.isRequired,
    responsibleUsers: PropTypes.array.isRequired,
    showContingentDrawer: PropTypes.func.isRequired,
    showPrereqDrawer: PropTypes.func.isRequired,
    onDeleteContingentClick: PropTypes.func.isRequired,
    statuses: PropTypes.array.isRequired,
    departments: PropTypes.array.isRequired,
    communities: PropTypes.array.isRequired,
    contingentTasks: PropTypes.array.isRequired,
    successorTasks: PropTypes.array.isRequired,
    isProjectWidgetActive: PropTypes.bool.isRequired,
    projects: PropTypes.array.isRequired,
    phases: PropTypes.array.isRequired,
    isTaskStepsActive: PropTypes.bool.isRequired,
    isTaskDependenciesActive: PropTypes.bool.isRequired,
    isProjectIdRequiredForLocationTask: PropTypes.bool.isRequired
};

export default LocationTaskDetailDrawerForm;
